/**
 * Utility function to retrieve active OneTrust groups IDs.
 *
 * @returns {string[]} An array of active group IDs.
 */
export const getOneTrustActiveGroupsIds = (): string[] => {
  if (!window.OnetrustActiveGroups) {
    console.warn(
      'OneTrust is not initialized or active groups are not available.'
    );

    return [];
  }

  return window.OnetrustActiveGroups.split(',').filter(group => group !== '');
};
